// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { isDarkMode } from '../../provider/types';
import { blue } from '../primitiveColors/blue';
import { common } from '../primitiveColors/common';
import { cyan } from '../primitiveColors/cyan';
import { green } from '../primitiveColors/green';
import { grey } from '../primitiveColors/grey';
import { mutedBlue, mutedGreen, mutedPurple, mutedRed, mutedYellow } from '../primitiveColors/muted';
import { orange } from '../primitiveColors/orange';
import { purple } from '../primitiveColors/purple';
import { red } from '../primitiveColors/red';
import { transparency } from '../primitiveColors/transparency';
import { yellow } from '../primitiveColors/yellow';
var light = {
    level0: common.white,
    level50: grey[25],
    level100: grey[50],
    level200: grey[100],
    level300: grey[200],
    accent: blue[500],
    action: blue[50],
    actionBold: blue[500],
    modalOverlay: transparency.gray.dark[400],
    tooltip: grey[700],
    state: {
        hover0: transparency.gray.dark[50],
        hover50: grey[100],
        hover100: grey[200],
        hover200: grey[300],
        hover300: grey[400],
        selected1: blue[50],
        selected2: blue[100],
        selected3: blue[200],
        selectedAlt: transparency.gray.dark[100],
        selectedTransparent: transparency.blue.light[100],
        selectedTransparent2: transparency.blue.light[200],
        disabled1: grey[200],
        disabled2: grey[300],
        disabled3: grey[400],
        disabledTransparent: transparency.gray.dark[100]
    },
    status: {
        error1: red[50],
        error2: red[100],
        errorBold1: red[500],
        errorBold2: red[600],
        errorBold3: red[700],
        errorBold4: red[500],
        info: blue[50],
        infoBold: blue[500],
        infoBold2: blue[600],
        info2: blue[200],
        warning1: yellow[50],
        warning2: yellow[100],
        warning3: yellow[300],
        warningBold1: yellow[500],
        warningBold2: yellow[600],
        success: green[50],
        successBold: green[300],
        successBold2: green[300],
        success2: green[100],
        special: purple[50],
        specialBold: purple[600],
        autonomyFail: orange[50],
        autonomyFailBold: orange[500],
        autonomyPass: cyan[200],
        autonomyPassBold: cyan[400],
        hover: {
            error: red[100],
            errorBold: red[700],
            info: blue[100],
            infoBold: blue[600],
            success: green[100],
            successBold: green[400],
            warning: yellow[100],
            warningBold: yellow[600],
            special: purple[100],
            specialBold: purple[700]
        },
        active: {
            error: red[200],
            errorBold: red[800],
            info: blue[200],
            infoBold: blue[700],
            success: green[200],
            successBold: green[500],
            warning: yellow[200],
            warningBold: yellow[700],
            special: purple[200],
            specialBold: purple[800]
        }
    },
    template: {
        cards: common.white,
        dialogs: common.white,
        pageBackground: grey[50],
        panels: grey[50],
        paper: common.white,
        popOvers: common.white,
        toolbars: grey[100]
    }
};
var dark = {
    level0: grey[950],
    level50: grey[900],
    level100: grey[850],
    level200: grey[800],
    level300: grey[700],
    accent: blue[400],
    action: grey[600],
    actionBold: blue[700],
    modalOverlay: transparency.gray.dark[400],
    tooltip: grey[700],
    state: {
        hover0: transparency.gray.light[50],
        hover50: grey[900],
        hover100: grey[850],
        hover200: grey[800],
        hover300: grey[700],
        selected1: mutedBlue[800],
        selected2: mutedBlue[700],
        selected3: mutedBlue[600],
        selectedAlt: transparency.gray.light[100],
        selectedTransparent: transparency.gray.light[100],
        selectedTransparent2: transparency.gray.light[200],
        disabled1: grey[600],
        disabled2: grey[500],
        disabled3: grey[400],
        disabledTransparent: transparency.gray.light[100]
    },
    status: {
        error1: mutedRed[900],
        error2: mutedRed[800],
        errorBold1: mutedRed[600],
        errorBold2: mutedRed[500],
        errorBold3: red[600],
        errorBold4: red[400],
        info: mutedBlue[800],
        infoBold: blue[500],
        infoBold2: mutedBlue[600],
        info2: mutedBlue[600],
        warning1: mutedYellow[950],
        warning2: mutedYellow[900],
        warning3: yellow[700],
        warningBold1: yellow[300],
        warningBold2: yellow[600],
        success: mutedGreen[900],
        successBold: green[600],
        successBold2: green[200],
        success2: mutedGreen[800],
        special: mutedPurple[900],
        specialBold: purple[400],
        autonomyFail: orange[800],
        autonomyFailBold: orange[500],
        autonomyPass: cyan[700],
        autonomyPassBold: cyan[400],
        hover: {
            error: red[900],
            errorBold: red[600],
            info: blue[600],
            infoBold: blue[500],
            success: green[800],
            successBold: green[600],
            warning: mutedYellow[800],
            warningBold: mutedYellow[500],
            special: purple[800],
            specialBold: purple[400]
        },
        active: {
            error: red[800],
            errorBold: red[500],
            info: blue[500],
            infoBold: blue[400],
            success: green[700],
            successBold: green[500],
            warning: mutedYellow[700],
            warningBold: mutedYellow[400],
            special: purple[700],
            specialBold: purple[300]
        }
    },
    template: {
        cards: grey[850],
        dialogs: grey[800],
        pageBackground: grey[950],
        panels: grey[900],
        paper: grey[850],
        popOvers: grey[850],
        toolbars: grey[950]
    }
};
export var background = function(mode) {
    return isDarkMode(mode) ? dark : light;
};

//# sourceMappingURL=background.js.map